<template>
  <div id="app">
    <NavBar id="nav-bar"/>
    <router-view id="router"/>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue"
export default {
  components: {
    NavBar
  }
}
</script>
<style lang="scss">
body{
  margin:0;
  padding: 0;
}
a{
  text-decoration: none;
  display:inline-block;
}
img{
  border: none;
}
#app{
  background-color: #fefefe;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  min-width: 1256px;
}
#nav-bar{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
}
#router{
  margin-top: 92px;
}
</style>
